export default "__VITE_ASSET__5015b1fd__"